module.exports = __webpack_public_path__ + "static/media/5580.87024d59.jpg";